module.exports = __webpack_public_path__ + "static/media/thumb_AVBH4771_1024a.30d055d6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cycle/kama_yunek/thumb_AVBH4771_1024a.jpg
// module id = 155
// module chunks = 0